import { render, staticRenderFns } from "./InscricaoEstadualTypeField.vue?vue&type=template&id=8c4034ba&scoped=true&"
import script from "./InscricaoEstadualTypeField.vue?vue&type=script&lang=js&"
export * from "./InscricaoEstadualTypeField.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoEstadualTypeField.vue?vue&type=style&index=0&id=8c4034ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4034ba",
  null
  
)

export default component.exports